import store from "../../store/store";

export default class ProcessoService {
  constructor(resource) {
    this._resource = resource;
  }

  alterApi(params, call) {
    return call(params)
      .then(
        res => {
          if (!res.ok) {
            return null;
          }
          return res.json();
        },
        err => {
          console.log(err);
          return null;
        }
      )
      .then(res => {
        if (res && res.type && res.token) {
          store.dispatch("setToken", `${res.type} ${res.token}`);
          store.dispatch("setRefreshToken", res.refreshToken);
        }
        return res;
      });
  }

  setTokenUsuario({ login, senha, token }) {
    return this.alterApi(
      { login, senha, token },
      ({ login, senha, token }) => {
        return this._resource.post(
          `${process.env.AUTH_URL}auth/usuario`,
          {
            login,
            senha,
            token
          }
        );
      }
    );
  }

  setTokenContato({ cpf, email }) {
    return this.alterApi(
      { cpf, email },
      ({ cpf, email }) => {
        return this._resource.post(
          `${process.env.AUTH_URL}auth/contato`,
          { email, cpf }
        );
      }
    );
  }

  setTokenResponsavel({ cpf, nascimento }) {
    return this.alterApi(
      { cpf, nascimento },
      ({ cpf, nascimento }) => {
        return this._resource.post(
          `${process.env.AUTH_URL}auth/responsavel`,
          { cpf, nascimento }
        );
      }
    );
  }

  checkToken() {
    const refreshToken = store.state.refreshToken;

    return this.alterApi(
      { refreshToken },
      ({ refreshToken }) => {
        return this._resource.post(
          `${process.env.AUTH_URL}check-refresh`,
          { refresh_token: refreshToken }
        );
      }
    );
  }

  checkValidateToken() {
    const token = store.state.token;

    return this.alterApi(
      { token },
      ({ token }) => {
        return this._resource.post(
          `${process.env.AUTH_URL}check`,
          { token }
        );
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/web/AuthService.js